import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";
import GroupAllUsers from "../FieldTags/GroupAllUsers";

const newPlan = window.location.pathname === "/xplans/new";

const Protocol = ({ protocol, handleChange, xplans, protocols, required }) => {
    return (
        <div id="protocol" className="planField">
            <GroupAllUsers />
            {/*
            <Tooltip
                title="(re-select study to remove from list)"
                placement="top-start"
            >
            </Tooltip>
            */}
            <Autocomplete
                id="protocol-field"
                name="protocol"
                multiple
                autoHighlight
                options={protocols}
                value={protocol ? protocol.split(",") : []}
                onChange={(_, newValue) => handleChange("protocol", newValue)}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={xplanLabels.protocol}
                        InputLabelProps={{
                            shrink: true,
                            required: required.includes("protocol")
                        }}
                        required={required.includes("protocol")}
                    />
                }
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"protocol"} />}
        </div>
    );
};

export default Protocol;